<template>
  <v-container>
    <v-snackbar Bottom :timeout="2000" color="green" v-model="snackbar_">
      Uploaded Successfully !
    </v-snackbar>
    <v-row v-show="showw">
      <v-col cols="12" >
        <v-card
          style="background-image: linear-gradient(to bottom right, #07a, #cdcdc4);"
          dark
        >
          <div style=" text-align:center;    color: #000;">
            <h4>{{ resultArray[0].ItemName }}</h4>
            <h4>{{ resultArray[0].ItemNameArabic }}</h4>
          </div>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
             
              <v-card-title
                class=""
                v-text="resultArray[0].Category"
              ></v-card-title>

              <v-card-subtitle
                v-text="resultArray[0].SubCategory"
              ></v-card-subtitle>
              <div
                style=" text-align:left;    color:#fff;    padding-left: 15px;"
              >
                <h4>
                  <small style="color:#000">Retail Rate</small>
                  {{
                    formatPrice(resultArray[0].RetailRateFinal)
                  }}&nbsp;&nbsp;<small style="color:#f3d921">{{
                    Currency
                  }}</small>
                </h4>
                <h4>
                  <small style="color:#000">Stock</small>
                  {{ resultArray[0].CurrentStock }}
                </h4>
              </div>

              <v-card-text class="text--primary">
                <div>
                  <v-icon style="color: #000;">mdi-barcode</v-icon>
                  <v-title style="color:#fff;font-size: 14px;"
                    >&nbsp;&nbsp;{{ resultArray[0].Barcode }}</v-title
                  >
                </div>
              </v-card-text>
            </div>
            <div v-if="slides">
              <!-- <sub>{{slides[0].FileURL}}</sub> -->
              <v-avatar class="ma-3" size="125" tile >
              <v-img  :src="slides[0].FileURL" @click="goSliderView"></v-img>
            </v-avatar>
            </div>
            <div v-else>
              <sub>no</sub>
            </div>


<!-- <sub>{{ resultArray[0].Attachments[0].FileURL || null }}</sub> -->
           
            <!-- <v-avatar class="ma-3" size="125" tile >
              <v-img v-if="resultArray[0].Attachments[0].FileURL" :src="resultArray[0].Attachments[0].FileURL" @click="goSliderView"></v-img>
              <v-img v-else :src="imageURL" @click="goSliderView"></v-img>
             
            </v-avatar> -->
          </div>
        </v-card>
        <v-card class="mx-auto" style="box-shadow:none;">
          <v-row>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Brand <br /><b>{{ resultArray[0].Brand }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" hidden>
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Alt Unit Id <br /><b>{{ resultArray[0].AltUnitId }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Item Code <br /><b>{{ resultArray[0].ItemCode }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" hidden>
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Item Id <br /><b>{{ resultArray[0].ItemId }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Unit<br /><b
                  >{{ resultArray[0].Unit }}
                  <span v-if="resultArray[0].Conversion != 1"
                    >(1 × {{ resultArray[0].Conversion }})</span
                  ></b
                >
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Reorder Level <br /><b>{{ resultArray[0].ReorderLevel }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Reorder Quantity <br /><b>{{ resultArray[0].ReorderQty }}</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Discount <br /><b>{{ formatPrice(Discountamnt) }}</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Discount Perc <br /><b>{{ resultArray[0].DiscountPerc }}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Made In <br /><b>{{ resultArray[0].MadeIn }}</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <!-- @click="wholeModal = !wholeModal" -->
              <v-card-subtitle
              @click="OpenModalContent('wholeModal')"
              
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Wholesale Rate <br /><b style="color:orange"
                  >{{ formatPrice(resultArray[0].WholeSaleRateFinal) }}
                  <small style="color:black">{{ Currency }}</small></b
                >
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
             
                @click="OpenModalContent('retailModal')"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Retail Rate <br /><b style="color:orange"
                  >{{ formatPrice(resultArray[0].RetailRateFinal)
                  }}<small style="color:black"> {{ Currency }}</small></b
                >
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                
                @click="OpenModalContent('retailModalex')"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Retail Rate <span style="font-size: 10px;">(Excluding Tax & Discount)</span><br /><b style="color:orange"
                  >{{ formatPrice(resultArray[0].RetailRate)
                  }}<small style="color:black"> {{ Currency }}</small></b
                >
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" v-show="showCost">
              <v-card-subtitle
               
                @click="OpenModalContent('costModal')"
                color="orange"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Cost <br /><b style="color:orange;"
                  >{{ formatPrice(resultArray[0].Cost)
                  }}<small style="color:black"> {{ Currency }}</small></b
                >
              </v-card-subtitle>
            </v-col>
               <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" v-show="showSupp == true && resultArray[0].Supplier != ''">
              <v-card-subtitle
             
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Supplier <br /><b style="color:orange;"
                  >{{ resultArray[0].Supplier
                  }}</b
                >
              </v-card-subtitle>
            </v-col>


            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Tax <br /><b
                  >{{ formatPrice(Taxamount) }} ({{
                    resultArray[0].TaxPerc
                  }}
                  %)</b
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-row  v-if="showprint">
             <v-col cols="12" class="text-center">
            <v-btn color="defualt" @click="Print_">
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row >
    <v-row v-show="notshoww" hidden>
        <v-col cols="12" >
        <v-card
          class="mx-auto"
          max-width="344"
          style="text-align:center;box-shadow: none;"
        >
          <v-img
            style="height: 80vh;"
            :src="require('@/assets/images/notfound.png')"
          ></v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="costModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update Cost</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{ formatPrice(resultArray[0].Cost) }}
                  <small>{{ Currency }}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                type="number"
                v-model="cost__"
                label="Enter Cost"
                placeholder=""
                autofocus
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="costModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="updateCost"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="retailModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update Retail Rate</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{ formatPrice(resultArray[0].RetailRateFinal) }}
                  <small>{{ Currency }}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="retail__"
                label="Enter Retail Rate"
                placeholder=""
                autofocus
                outlined
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="retailModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="updateRetail"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="retailModalex" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update Retail Rate (Excluding tax)</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{ formatPrice(resultArray[0].RetailRate) }}
                  <small>{{ Currency }}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="exretail__"
                label="Retail Rate (Excluding Tax & Discount)"
                placeholder=""
                autofocus
                type="number"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="retailModalex = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="updateRetailex"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="wholeModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update wholesale Rate</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{ formatPrice(resultArray[0].WholeSaleRateFinal) }}
                  <small>{{ Currency }}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="whole__"
                label="Enter wholesale rate"
                placeholder=""
                autofocus
                type="number"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="wholeModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="updateWhole"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
    <v-dialog
    v-model="sliderview"
    fullscreen
    :scrim="false"
    transition="dialog-bottom-transition"
    style="background:#fff;"
  >
  <v-card>
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="sliderview = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Attachments</v-toolbar-title>
     
       
    </v-toolbar>
         <v-container>
          <v-row>
           
            <v-carousel
  
    height="300"
    v-if="slides"

  >
  <v-carousel-item
    
      v-for="(item,i) in slides"
      :key="i"
      :src="item.FileURL"
      cover
      
    >
    <v-btn
    class="mx-2 mt-2"
    fab
    dark
    small
    absolute
    right
    hidden
    color="error"
    @click="deletePic(i)"
  >
    <v-icon dark>
      mdi-delete 
    </v-icon>
  </v-btn>
  <v-btn
  hidden
  class="mx-3 mt-2 mr-16"
  fab
  dark
  small
  absolute
  right
  color="success"
  @click="filePick(i)"
>
  <v-icon dark>
    mdi-pen 
  </v-icon>
</v-btn>
  </v-carousel-item>
    
  </v-carousel>
 
          </v-row>
          <input
          type="file"
          id="my_file"
          style="display:none;"
          @change="convert2"
          accept="image/*"
        />
       
      </v-container>
    <v-container style="margin-top:2em;">  
      <v-row cols="12" style="justify-content: center;">
      <div class="file-upload">
        <span>Choose files</span>
       
          <input type="file" ref="fileInput"  name="file" multiple>
      </div>
      </v-row>
        <v-row cols="12" style="justify-content: center;margin-top:20px;">
          <v-btn
          
              class="mx-2"
              fab
              dark
              @click="uploadImages"
              right
              color="primary"
            >
              <v-icon dark>
                mdi-upload
              </v-icon>
            </v-btn>
        </v-row>
     
         </v-container>

    <v-divider></v-divider>
    
  </v-card>
  
  </v-dialog>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          color: "#1F7087",
          src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
          title: "Supermodel",
          artist: "Foster the People"
        }

      ],
      sliderview:false,
      snack:{
        snackbar:false,
        msg:''
      },
      showCost:null,
      showSupp: JSON.parse(localStorage.getItem("showsupp")),
      snackbar: false,
      resultArray: [],
      url: localStorage.getItem("BaseURL"),
      barcode: localStorage.getItem("barcode"),
      Currency: localStorage.getItem("Currency"),
      imageURL: "",
      showw: null,
      notshoww:null,
      Timeout: localStorage.getItem("display_time"),
      costModal: false,
      cost__: "",
      retail__: "",
      wholeModal: false,
      whole__: "",
      retailModal: false,
      retailModalex:false,
      Taxamount: "",
      Discountamnt: "",
      URL__: localStorage.getItem("BaseURL"),
      ios: false,
      shomsg:'',
      showprint:true,
      exretail__:"",
      slides:[],
      updateId:'',
      editResult : "",
      maxWidth : 200,// Maximum width for the resized image
      maxHeight : 100, // Maximum height for the resized image
      quality:  0.8,
      editResult_:'',
      snackbar_:false,
      permission:[],
      role:localStorage.getItem('role'),
      showperm:false,
      updateperm:false,
      HideCostpreference:localStorage.getItem("HideCost_preference") || '',
      stoptimer:false
    };
  },
  created() {
   
  },
  mounted() {
    // alert(this.Timeout)
    this.string = this.URL__;
    this.substring = "https";
    this.Check_url = this.string.includes(this.substring);
    if (this.Check_url == true) {
      // alert(this.Check_url)
      this.ios = this.Check_url;
    } else {
      this.ios = this.Check_url;
    }

    if(localStorage.getItem("HideCost") == "True")
     {
     
      this.showCost = false
      // alert("FFF "+localStorage.getItem("HideCost"))
     }
     else
     {
      // alert("TTT "+localStorage.getItem("HideCost") +  this.HideCostpreference)
      if(this.HideCostpreference == "true")
      {
        this.showCost = true
      }else{
        this.showCost = false
      }
     
      
     }

     this.permission = JSON.parse(localStorage.getItem("permissionList"));
    //  console.log(this.permission[0].crud[0])
    

    window.searchResult = this.searchResult;
    window.upcostResult = this.upcostResult;
    window.upretailResult = this.upretailResult;
    window.upwholeResult = this.upwholeResult;
     window.getResult = this.getResult;
     window.UpdateCost_ = this.UpdateCost_;
     window.UpdateRetail_ = this.UpdateRetail_;
     window.UpdateRetailex_ = this.UpdateRetailex_;
     window.UpdateWhole_ = this.UpdateWhole_;
     window.SaveItemImage_ = this.SaveItemImage_;
     window.quitback = this.quitback;
     window.imgPicUpload = this.imgPicUpload;
    
    
    this.getitemDetails();
  },
  methods: {
    OpenModalContent(var_)
    {
      this.stoptimer = true
          let Modal = var_;  
          this.showperm = this.permission[0].crud[2];
          console.log(this.showperm);    
          if(this.showperm == false)
          {
            if(this.role == "Administrator") this.showperm = true
            console.log('hide');    
          }else{
            console.log('show');
          }

          console.log(this.showperm);    
          switch(Modal){  

          case 'wholeModal':  
          this.showperm ?  this.wholeModal = true : this.wholeModal = false;
          break;  
          
          case 'retailModal':  
          this.showperm ?  this.retailModal = true : this.retailModal = false;
          break;
          
          case 'retailModalex':  
          this.showperm ?  this.retailModalex = true : this.retailModalex = false;
          break;
         
          case 'costModal':  
          this.showperm ?  this.costModal = true : this.costModal = false; 
          break;
         
          default:  
          console.log(var_);  
          }  

    },
    getitemDetails() {
      let vm = this;
      const dummyobj = {
            AttachmentId:0,
            Caption:"",
            ContentB64:"",
            FileExtension:".png",
            FileURL:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU",
            ParentId:0,
            Remarks:""
      }
      if (this.ios == true) {
      this.axios
        .get(
          this.url + "/api/item/getitembybarcode?barcode=" + this.barcode,
          null
        )
        .then(response => {
          if (response.status === 200) {
            this.img = response.data.Image;
this.resultArray.push(response.data);
if(response.data.Attachments.length > 0)
{
 
  this.slides = response.data.Attachments
  // this.slides.push(dummyobj)
}else
{
  this.slides.push(dummyobj)
}


this.Discountamnt =
  (response.data.RetailRate * response.data.DiscountPerc) / 100;
this.Taxamount =
  ((response.data.RetailRate - this.Discountamnt) *
    response.data.TaxPerc) /
  100;
if (this.img == null || this.img == "") {
  this.imageURL =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU";
} else {
  const base64_response = response.data.Image;
  this.imageURL = "data:image/png;base64," + base64_response;
}
this.showw = true;
  
  this.checkGoHistory()
  
            // Do something with the response
          } else if (response.status === 404) {
            console.log('Error - :', response.status);
            window.history.back()
          }
        })
        .catch(error => this.goBack());
       
      }else{
       
       
        //------------------------------------------------------------------------
          try {
          const myobj = {
           barcode: this.barcode
          };
        var obj = JSON.stringify(myobj);
        var method = "Get";
        var funtn_ = "getResult";
        var url_ = this.url + "/api/item/getitembybarcode?barcode=" + this.barcode;
        
            var JsonData = 
            {
              "Json":
              [  
                {"URL":url_,"Method":method, "Params":obj,"Function":funtn_}
              ]

            };
              
          
            var aaa = JSON.stringify(JsonData);
            this.SendOBJ = aaa ;
            window.interface.CommonMethod(this.SendOBJ);
          } catch (error) {
                  // handle the error
                  console.error("catch"+error);
          }

  
       
      }
    },
    checkGoback()
    {
      if(this.stoptimer != true){window.history.back()}
    },
    checkGoHistory()
    {
     
       if (this.Timeout != 0) {
        setTimeout(() => this.checkGoback(), this.Timeout + "000");
       }
    },
    quitback()
    {
      this.$router.push("pdtscan");
    },
    deletePic(i)
    {
      // console.log(i) 
      this.slides.splice(i, 1);
      this.uploadPic();
    },
    uploadPic()
    {

      const myobj = this.slides;
      // alert(this.editResult_);

      if (this.ios == true) {
       this.axios
          .post(this.url + "/api/item/UploadItemAttachments?itemId="+this.resultArray[0].ItemId, myobj)
          .then(
            (response) => {
              console.log("res" + JSON.stringify(response.data.token));
             this.snackbar = true;
            //  location.reload();
             this.getitemDetails();
            },
            (error) => {
              console.log("error" + error);
             
            }
          );
      }else{
      // const endpoint = this.url + "http://eademoapi.linkwayapps.com/api/Item/UploadItemAttachments?ItemId="+this.resultArray[0].ItemId;
      const endpoint = "http://eademoapi.linkwayapps.com/api/Item/UploadItemAttachments?ItemId="+this.resultArray[0].ItemId;
      const obj23 = [ {
           "ContentB64":"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",
           "FileExtension":".png"
            }];
      try {
        
        

        // const options = {
        //     method: 'POST',
        //     mode: 'cors',
        //     headers: {
        //       'Content-Type': 'application/json',
        //       'Access-Control-Allow-Origin': '*',
        //     },
        //     body: JSON.stringify(obj23),
        //   };

        //   fetch(endpoint, options)
        //     .then(response => response.json())
        //     .then(data => console.log(data))
        //     .catch(error => console.error(error));
      } catch (error) {
        console.log(error);
      }

      }
      
      // else
      // {
      //   try {
      //     let imgindex = localStorage.getItem("Filepickindex")
          

      //     const obj23 =  {
      //      ContentB64:"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",
      //      FileExtension:".png"
      //       }
            
      //         var obj = JSON.stringify(obj23);//JSON.stringify(senditemObj);
      //         var method = "Post";
      //         var funtn_ = "imgPicUpload";
      //         var url_ = this.url + "/api/Item/UploadItemAttachments?ItemId="+this.resultArray[0].ItemId;
              
      //         // var JsonData = 
      //         //   {
      //         //     "Json":
      //         //     [  
      //         //       {"URL":url_,"Method":method, "Params":obj,"Function":funtn_}
      //         //     ]

      //         //   };
      //           var JsonData = {
      //               Json: [
      //                 { URL: url_, Method: method, Params: obj, Function: funtn_ },
      //               ],
      //            };
                  
              
      //           var aaa = JSON.stringify(JsonData);
      //           this.SendOBJ = aaa ;
      //           window.interface.CommonMethod(this.SendOBJ);
      //           // alert(this.SendOBJ)
      //     } catch (error) {
      //             // handle the error
      //           alert("catch"+error);
      //     }

      // }
    },
    imgPicUpload(res)
    {
      let obj = JSON.parse(res);
      alert("ok ya"+res)
    },

    async uploadImages() {
      try{
      let apiUrl;
      // if (this.ios == true) {
        apiUrl = this.url + "/api/item/UploadBigAttachments?itemId="+this.resultArray[0].ItemId;//"http://eademoapi.linkwayapps.com/api/Item/UploadItemAttachments?ItemId=" + 1957
        var formData = new FormData();
      const files = this.$refs.fileInput.files;
      var sendAPi = apiUrl;
      // alert("URL "+apiUrl+" ");
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
  // try{

  
      var request = new XMLHttpRequest();
     
     
     
      request.open('post', sendAPi, true);
      // request.withCredentials = true;
      request.setRequestHeader('Access-Control-Allow-Origin', '*');
      request.setRequestHeader('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS');
      request.setRequestHeader('Access-Control-Allow-Headers', 'multipart/form-data');
      request.onload = function() {
        if (request.status === 200) {
          alert('Request was successful');
          console.log(request.responseText);
          this.snackbar = true;
        } else {
          alert('Request failed');
        }
      };
      request.send(formData);
    }
    catch(error)
    {
      alert(error)
    }
      // }
      // else
      // {
       
        // try {
        //   var formData2 = new FormData();
        //   const files = this.$refs.fileInput.files;
     
        //   for (let i = 0; i < files.length; i++) {
        //     formData2.append('files', files[i]);
        //    }
        //     const obj23 =  {
           
        //     }
            
        //       var obj = formData2;//JSON.stringify(senditemObj);
        //       var method = "Postimage";
        //       var funtn_ = "imgPicUpload";
        //       var url_ = this.url + "/api/Item/UploadItemAttachments?ItemId="+this.resultArray[0].ItemId;
              
              
        //         var JsonData = {
        //             Json: [
        //               { URL: url_, Method: method, Params: obj, Function: funtn_ },
        //             ],
        //          };
                  
              
        //         var aaa = JSON.stringify(JsonData);
        //         this.SendOBJ = aaa ;
        //         window.interface.CommonMethod(this.SendOBJ);
        //         // alert(this.SendOBJ)
        //   } catch (error) {
        //           // handle the error
        //         alert("catch"+error);
          // }
      // }
      
    // }
    // catch(error)
    // {
    //   alert("ee "+error.message);
    // }
      
    },
  
    getResult(res) {
        // let obj = JSON.parse(res);
      
     
      if(res == "null")
      {
        //  alert("Item Not Found !")
             this.$router.push("pdtscan");
             this.showw = false;
      }else{
        if(res == "Barcode deos not exist")
      {
          // alert(res);
          this.$router.push("pdtscan");
        
      }else{
        //  this.showw = true;
         let obj = JSON.parse(res);
        //  alert("Result " + obj.Image);
        const dummyobj = {
            AttachmentId:0,
            Caption:"",
            ContentB64:"",
            FileExtension:".png",
            FileURL:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU",
            ParentId:0,
            Remarks:""
      }
          if (res != null) {
          this.showw = true;
              this.img = obj.Image;
              this.resultArray.push(obj);
             
              if(obj.Attachments.length > 0)
                  {
                  
                    this.slides = obj.Attachments
                    // this.slides.push(dummyobj)
                  }else
                  {
                    this.slides.push(dummyobj)
                  }
                localStorage.setItem("pitemname",obj.ItemName)
                 localStorage.setItem("prate",obj.RetailRate)
              this.Discountamnt =
                (obj.RetailRate * obj.DiscountPerc) / 100;
              this.Taxamount =
                ((obj.RetailRate - this.Discountamnt) *
                  obj.TaxPerc) /
                100;
              if (this.img == null || this.img == "") {
                this.imageURL =
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU";
              } else {
                const base64_res = obj.Image;
                this.imageURL = "data:image/png;base64," + base64_res;
              }
              this.showw = true;
              this.checkGoHistory();
            } else {
               this.showw = false;
            }
      }


      }
    },
   
     searchResult(response1) {
     
       const response = JSON.parse(response1);
      if(response1 == "null")
      {
        //  alert("Item Not Found !")
         this.snack.msg = "Item Not Found !";
              this.snack.snackbar = true;
              this.$router.push("pdtscan");
      }else{
      // alert("Ashik" +response.ItemId)
       if (response != null) {
          this.showw = true;
              this.img = response.Image;
              this.resultArray.push(response);

              this.Discountamnt =
                (response.RetailRate * response.DiscountPerc) / 100;
              this.Taxamount =
                ((response.RetailRate - this.Discountamnt) *
                  response.TaxPerc) /
                100;
              if (this.img == null || this.img == "") {
                this.imageURL =
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU";
              } else {
                const base64_response = response.Image;
                this.imageURL = "data:image/png;base64," + base64_response;
              }
              this.showw = true;
            } else {
               this.showw = false;
            }
            }
    },

    formatPrice(value) {
      this.number = localStorage.getItem("symbol");
      let val = (value / 1).toFixed(this.number).replace(".", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    SplitT(Date) {
      return Date.split("T")[0];
    },
   
  
    filePick(i)
    {
      document.getElementById("my_file").click();
      // console.log("Index "+ i)
      localStorage.setItem("Filepickindex",i)
      event.stopPropagation();
    },
    // convert() {
    //   var file = document.querySelector("input[type=file]").files[0];
    //   var reader = new FileReader();
    //   var vm = this;
    //   reader.onload = function(e) {
    //     // alert(e.target.result);
    //     // vm.sendimgurl(e.target.result);
    //     // vm.imageURL = e.target.result;
    //     // this.Cimg = e.target.result.replace("data:image/png;base64,", "");
    //   };
    //   reader.onerror = function(error) {
    //     // alert(error);
    //     this.snack.msg = "Error";
    //           this.snack.snackbar = true;
    //   };
    //   reader.readAsDataURL(file);
    // },
    convert2() {
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();
      var vm = this;
      reader.onload = function(e) {
        // console.log(e.target.result);
        // vm.sendimgurl(e.target.result);
        // vm.imageURL = e.target.result;
        let imgset = localStorage.getItem("Filepickindex");
      
        vm.slides[imgset].ContentB64 =  vm.splitBase64OnCommaWithoutDecode(
          
        vm.reduceBase64Length(e.target.result, 200, 150, 0.8, function(reducedBase64String) {
  // Upload the reduced base64 string
          vm.editResult_ = vm.splitBase64OnCommaWithoutDecode(reducedBase64String);
         })
        );
        // vm.slides[imgset].FileURL =  vm.splitBase64OnCommaWithoutDecode( e.target.result);
        // console.log(" ext "+ ext)
      };
      reader.onerror = function(error) {
        // alert(error);
        this.snack.msg = "Error";
        this.snack.snackbar = true;
      };
      reader.readAsDataURL(file);
    },

splitBase64OnCommaWithoutDecode(str) {
  const regex = /^data:[^,]+,/;
  const matches = str.match(regex);
  const base64Data = str.slice(matches[0].length);
  return base64Data;
},

    sendimgurl(imgencode) {

      // alert("img " + imgencode);
      // this.Img__ = imgencode.replace(/^data:image\/[a-z]+;base64,/, "");
      // this.barcd = localStorage.getItem("barcode");

      if (this.ios == true) {
        console.log("ss")
      }
      else{
        const myobj = {
          ContentB64:   imgencode.replace(/^data:image\/[a-z]+;base64,/, ""),
          FileExtension:  ".png",
        };
        var obj = JSON.stringify(myobj);
        var method = "Post";
        var funtn_ = "imgPicUpload";
        var url_login = this.url + "/api/Item/UploadItemAttachments?ItemId="+this.resultArray[0].ItemId;

        var JsonData = 
      {
        "Json":
        [  
           {"URL":url_login,"Method":method, "Params":obj,"Function":funtn_}
        ]

      };
        
    
      var aaa = JSON.stringify(JsonData);
      this.SendOBJ = aaa ;
       window.interface.CommonMethod(this.SendOBJ)
      }
    },

    //*********************************************************

  reduceBase64Length(base64String, maxWidth, maxHeight, quality, callback) {
  // Create a new image element
  var img = new Image();
  img.src = base64String;

  // Wait for the image to load
  img.onload = function() {
    // Create a canvas element
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    // Calculate the new image size while maintaining the aspect ratio
    var width = img.width;
    var height = img.height;
    if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
    }
    if (height > maxHeight) {
      width *= maxHeight / height;
      height = maxHeight;
    }

    // Set the canvas size to the new image size
    canvas.width = width;
    canvas.height = height;

    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0, width, height);

    // Convert the canvas to a new base64 encoded string with reduced size
    var reducedBase64String = canvas.toDataURL('image/jpeg', quality);

    // Invoke the callback function with the reduced base64 string
    callback(reducedBase64String);
  };
},


    //***********************************************************************************
    SaveItemImage_(res)
    {
    console.log("Image "+res)
    },
    
    updateCost() {
      this.uCost = this.cost__;
      this.barcd = localStorage.getItem("barcode");

       if (this.ios == true) {
      this.axios
        .put(
          this.url +
            "/api/item/UpdateCost?Barcode=" +
            this.barcd +
            "&Cost=" +
            this.uCost,
          null
        )
        .then(
          response => {
            window.location.reload();
            console.log("Result" + JSON.stringify(response.message));
            if (response.message == "Success") {
              (this.costModal = false), (this.snackbar = true);
            }
          },
          error => {
            console.log("error" + error);
            this.error = "Something went wrong..!";
          }
        );
       }else{

          //native call starts here
        this.uCost = this.cost__;
        this.barcd = localStorage.getItem("barcode");
        const myobj = {};
        var obj = JSON.stringify(myobj);
        var method = "Put";
        var funtn_ = "UpdateCost_";
        var url_login = this.url +"/api/item/UpdateCost?Barcode="+this.barcd+"&Cost="+this.uCost;

        var JsonData = 
      {
        "Json":
        [  
           {"URL":url_login,"Method":method, "Params":obj,"Function":funtn_}
        ]

      };
        
    
      var aaa = JSON.stringify(JsonData);
      this.SendOBJ = aaa ;
      window.interface.CommonMethod(this.SendOBJ)
       
       }
    },

    UpdateCost_(res)
    {
       console.log(res);
       window.location.reload();
    },
    updateRetail() {
      this.uRetail = this.retail__;
      this.barcd = localStorage.getItem("barcode");
        if (this.ios == true) {
      this.axios
        .put(
          this.url +
            "/api/item/UpdateRetailRateWithTax?Barcode=" +
            this.barcd +
            "&RetailRateWithTax=" +
            this.uRetail,
          null
        )
        .then(
          response => {
            window.location.reload();
            console.log("Result" + JSON.stringify(response.message));
            if (response.message == "Success") {
              (this.retailModal = false), (this.snackbar = true);
            }
          },
          error => {
            console.log("error" + error);
            this.error = "Something went wrong..!";
          }
        );
        }else
        {
        
       
        this.barcd = localStorage.getItem("barcode");
        const myobj = {};
        var obj = JSON.stringify(myobj);
        var method = "Put";
        var funtn_ = "UpdateRetail_";
        var url_login = this.url +"/api/item/UpdateRetailRateWithTax?Barcode="+this.barcd +"&RetailRateWithTax="+this.uRetail;

        var JsonData = 
      {
        "Json":
        [  
           {"URL":url_login,"Method":method, "Params":obj,"Function":funtn_}
        ]

      };
        
    
      var aaa = JSON.stringify(JsonData);
      this.SendOBJ = aaa ;
      window.interface.CommonMethod(this.SendOBJ)
        }
    },

    UpdateRetail_(res)
    {
       console.log(res);
       window.location.reload();
    },

    //****************************************************************updateRetailex
    updateRetailex() {
      this.uRetail = this.exretail__;
      this.barcd = localStorage.getItem("barcode");
        if (this.ios == true) {
      this.axios
        .put(
          this.url +
            "/api/item/updateretailrate?Barcode=" +
            this.barcd +
            "&RetailRate=" +
            this.uRetail,
          null
        )
        .then(
          response => {
           
            // console.log("Result" + JSON.stringify(response.message));/
            if (response.message == "Success") {
              (this.retailModal = false), (this.snackbar = true);
            }
            window.location.reload();
          },
          error => {
            console.log("error" + error);
            this.error = "Something went wrong..!";
          }
        );
        }else
        {
        
       
        this.barcd = localStorage.getItem("barcode");
        const myobj = {};
        var obj = JSON.stringify(myobj);
        var method = "Put";
        var funtn_ = "UpdateRetailex_";
        var url_login = this.url +"/api/item/updateretailrate?Barcode="+this.barcd +"&RetailRate="+this.uRetail;

        var JsonData = 
      {
        "Json":
        [  
           {"URL":url_login,"Method":method, "Params":obj,"Function":funtn_}
        ]

      };
        
    
      var aaa = JSON.stringify(JsonData);
      this.SendOBJ = aaa ;
      window.interface.CommonMethod(this.SendOBJ)
        }
    },

    UpdateRetailex_(res)
    {
       console.log(res);
       window.location.reload();
    },
    //****************************************************************
    updateWhole() {
      this.uwhole = this.whole__;
      this.barcd = localStorage.getItem("barcode");
         if (this.ios == true) {
      this.axios
        .put(
          this.url +
            "/api/item/UpdateWholeSaleRateWithTax?Barcode=" +
            this.barcd +
            "&WholeSaleRateWithTax=" +
            this.uwhole,
          null
        )
        .then(
          response => {
            window.location.reload();
            console.log("Result" + JSON.stringify(response.message));
            if (response.message == "Success") {
              (this.wholeModal = false), (this.snackbar = true);
            }
          },
          error => {
            console.log("error" + error);
            this.error = "Something went wrong..!";
          }
        );
         }else {
        

         
        this.barcd = localStorage.getItem("barcode");
        const myobj = {};
        var obj = JSON.stringify(myobj);
        var method = "Put";
        var funtn_ = "UpdateWhole_";
        var url_login = this.url +"/api/item/UpdateWholeSaleRateWithTax?Barcode="+this.barcd +"&WholeSaleRateWithTax="+ this.uwhole;

        var JsonData = 
      {
        "Json":
        [  
           {"URL":url_login,"Method":method, "Params":obj,"Function":funtn_}
        ]

      };
        
    
      var aaa = JSON.stringify(JsonData);
      this.SendOBJ = aaa ;
      // alert("obj"+this.SendOBJ);
      window.interface.CommonMethod(this.SendOBJ)
         }
    },
    UpdateWhole_(res)
    {
      console.log(res);
       window.location.reload();
    },


    ///////////////************************************************************************ */
    //result area 

    upcostResult(res)
    {       
      
            const obj21 = JSON.parse(res);       
            console.log("Result" + JSON.stringify(obj21.message));
            if (obj21.message == "Success") {
              //  alert("Updated Successfully.")
              this.costModal = false,
              this.snackbar = true;
              setTimeout( window.location.reload(), 1500)
              ;
            }
           
    },
    upretailResult(res)
    {       
      // alert("result "+res)
            const obj21 = JSON.parse(res);       
            console.log("Result" + JSON.stringify(obj21.message));
            if (obj21.message == "Success") {
              //  alert("Updated Successfully.")
              this.costModal = false,
              this.snackbar = true;
              setTimeout( window.location.reload(), 1500)
              ;
            }
           
    },
    upwholeResult(res)
    {       
      // alert("Whole 2 "+res)
            const obj21 = JSON.parse(res);       
            console.log("Result" + JSON.stringify(obj21.message));
            if (obj21.message == "Success") {
              //  alert("Updated Successfully.")
              this.costModal = false,
              this.snackbar = true;
              setTimeout( window.location.reload(), 1500)
              ;
            }
           
    },

    Print_()
    {
      localStorage.setItem("pbarcode",this.barcode);
      localStorage.setItem("pitemcode_",this.resultArray[0].ItemCode);
      localStorage.setItem("pitemname",this.resultArray[0].ItemName);
      localStorage.setItem("prate",this.resultArray[0].RetailRateFinal);
     
      this.$router.push("Printbarcode");
    },
    goBack()
    {
      // console.log("sam")
      this.$router.push("pdtscan");
      // this.showw = false;
      // this.snack.msg = "Item Not Found !";
      // this.snack.snackbar = true;
    },
    goSliderView()
    {
      this.sliderview = true;
    }
  }
};
</script>
<style scoped>
.file-upload {
  display: inline-block;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  border: 2px solid #ccc;
  background-color: #fff;
  color: #333;
  font-size: 16px;
  padding: 10px;
  cursor: pointer;
}

.file-upload input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}</style>
